module.exports = __webpack_public_path__ + "static/media/about-us.d801c412.jpg";